// 256 memorable English words — used to generate 12-word recovery phrases.
// 12 × log2(256) = 96 bits of entropy (well above the ~80-bit practical threshold).
// Words chosen for readability: short, common, no similar-looking pairs.

export const WORDLIST = [
    "acorn", "amber", "anchor", "apple", "arrow", "aspen", "atlas", "autumn",
    "azure", "badge", "bamboo", "barn", "basil", "beach", "beacon", "beaver",
    "berry", "birch", "bison", "blade", "blaze", "bloom", "blue", "bolt",
    "bonsai", "branch", "brass", "bread", "brick", "brim", "brook", "buffalo",
    "bulb", "cabin", "cactus", "camel", "candle", "canoe", "canyon", "cape",
    "carbon", "cargo", "castle", "cedar", "chalk", "charm", "cherry", "chill",
    "cider", "cinder", "clam", "cliff", "clock", "cloud", "clover", "cobalt",
    "cocoa", "comet", "coral", "cosmos", "cotton", "coyote", "crane", "crater",
    "crest", "crimson", "crow", "crystal", "cube", "dagger", "daisy", "dawn",
    "deer", "delta", "denim", "desert", "diamond", "dolphin", "drift", "dune",
    "dusk", "eagle", "ember", "emerald", "falcon", "fern", "fig", "finch",
    "flame", "flint", "flora", "forest", "fox", "frost", "galaxy", "garnet",
    "gecko", "ginger", "glacier", "gleam", "goose", "granite", "grape", "grove",
    "harbor", "harp", "harvest", "hawk", "heather", "hedge", "hickory", "honey",
    "horizon", "hummingbird", "ink", "iris", "island", "ivory", "ivy", "jade",
    "jasmine", "jet", "juniper", "kelp", "knight", "lagoon", "lake", "lantern",
    "lark", "laurel", "lava", "lemon", "lily", "linen", "lotus", "lunar",
    "lupine", "lynx", "magnet", "maple", "marble", "marsh", "meadow", "melon",
    "meteor", "mint", "mist", "moon", "moss", "mountain", "nebula", "nectar",
    "nest", "night", "oak", "oasis", "ocean", "olive", "onyx", "opal",
    "orange", "orbit", "orchid", "otter", "owl", "palm", "panda", "parrot",
    "peach", "pearl", "pebble", "pepper", "petal", "phoenix", "pine", "piper",
    "plum", "pollen", "pond", "poppy", "prairie", "prism", "puma", "quartz",
    "quill", "quiver", "rabbit", "rain", "raven", "reef", "ridge", "river",
    "robin", "rose", "ruby", "rust", "saddle", "sage", "salmon", "sand",
    "sapphire", "scarlet", "seal", "seed", "shade", "shell", "silver", "sky",
    "slate", "sleet", "snow", "solar", "sparrow", "spice", "spring", "spruce",
    "starling", "stone", "storm", "stream", "summit", "sun", "swallow", "swan",
    "tangerine", "thistle", "thorn", "thunder", "tiger", "topaz", "tulip", "tundra",
    "turquoise", "umber", "valley", "velvet", "violet", "walnut", "wasp", "water",
    "wave", "whale", "wheat", "willow", "winter", "wolf", "wren", "yarrow",
    "yew", "zebra", "zen", "zinc", "alder", "anvil", "apex", "arbor",
    "avocet", "beech", "boar", "clay", "cove", "crag", "creek", "delta",
    "dune", "eel", "elk", "fjord", "frond", "gale", "haze",  "kite",
];
